import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import ResetPassword from "views/auth/ResetPassword";
import { getToken } from "utils/cookies.helpers";

const ProtectedRoute = ({ children }) => {
  const token = getToken();
  if (!token) return <Navigate to="/auth/sign-in" replace />;
  return children;
};

const App = () => {
  return (
    <Routes>
      <Route path="reset-password" element={<ResetPassword />} />
      <Route path="auth/*" element={<AuthLayout />} />
      <Route
        path="admin/*"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
    </Routes>
  );
};

export default App;
